import styled, { css } from 'styled-components'
import { ICategoryType, IPublishedType, IStatusType } from 'store/taskManager/model'
import { TagType } from './index'

export interface IStyledTag {
  labelId?: number
  type?: TagType
}

enum CategoryTag {
  'connection' = 1,
  'payment',
  'openCabinet',
  'other',
  'support',
}

enum StatusTag {
  'briefing' = 1,
  'inProgress',
  'needInformation',
  'done',
  'reject',
  'research',
}

enum PublishedTag {
  'published' = 1,
  'unpublished',
}

export const StyledTag = styled.div<IStyledTag>`
  ${({ theme, labelId, type }) => css`
    height: 20px;
    padding: 1px 8px;
    border-radius: 23px;
    font-size: 12px;
    line-height: 1.3;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;

    button {
      padding: 2px 0 2px 8px;
      line-height: 0;
    }

    ${!type &&
    css`
      border: 1px solid ${theme.colors.dark};
    `}

    ${type === 'category' &&
    css`
      border: 1px solid ${theme.labels[CategoryTag[labelId || 1] as ICategoryType]};
      color: ${theme.labels[CategoryTag[labelId || 1] as ICategoryType]};
      background: transparent;

      button {
        fill: ${theme.labels[CategoryTag[labelId || 1] as ICategoryType]};
      }
    `}

    ${type === 'status' &&
    css`
      color: rgba(24, 26, 26, 0.7);
      border: 1px solid ${theme.labels[StatusTag[labelId || 1] as IStatusType]};
      background: ${theme.labels[StatusTag[labelId || 1] as IStatusType]};
    `}

    ${type === 'published' &&
    css`
      color: rgba(24, 26, 26, 0.7);
      border: 1px solid ${theme.labels[PublishedTag[labelId || 1] as IPublishedType]};
      background: ${theme.labels[PublishedTag[labelId || 1] as IPublishedType]};
    `}
  `}
`
